import { Link, useLocation } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-24 flex flex-col items-center text-center">
        <span className="w-20 h-20 rounded-full bg-background-100 text-primary-500 flex items-center justify-center text-4xl">
          <i className="ri-film-line" aria-hidden="true"></i>
        </span>
        <h1 className="mt-6 font-heading text-4xl md:text-6xl font-bold text-foreground-950">404</h1>
        <h2 className="mt-3 font-heading text-lg md:text-xl font-bold text-foreground-900">
          找不到这个页面
        </h2>
        <p className="mt-2 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>
        <p className="mt-3 text-sm text-foreground-600">
          页面可能已被移除或链接有误，回到首页继续浏览精彩影视吧
        </p>
        <div className="mt-7 flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            className="px-6 h-11 inline-flex items-center rounded-md bg-accent-500 text-secondary-950 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="px-6 h-11 inline-flex items-center rounded-md border border-background-300 text-foreground-700 text-sm hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            去搜索影视
          </Link>
        </div>
      </div>
    </Layout>
  );
}